import React from "react"
import { toast } from "react-toastify"

import { store } from "@redux"
import { productUnitsSymbol } from "constant"

const isStockLimited = (newOrderItem, increasedQuantity, showToast = true) => {
  if (!newOrderItem.stockManagement) return false

  const orderItems = store.getState().order.items

  const filteredOrderItems =
    orderItems.filter(oi =>
      oi.optionId === newOrderItem.optionId
    )

  const previousOrderItemQuantity =
    filteredOrderItems.reduce((total, oi) => total += oi.quantity, 0)

  const totalOrderItemInCart =
    previousOrderItemQuantity + increasedQuantity

  if (newOrderItem.availableQuantity >= totalOrderItemInCart) return false


  if (showToast) {
    const message =
      <span>
        {newOrderItem.foodName}{" "}
        {newOrderItem.isSimple ? "" : `- ${newOrderItem.optionName} `}
        حداکثر{" "}
        <b>{newOrderItem.availableQuantity} {productUnitsSymbol[newOrderItem.unit]}</b>{" "}
        موجود می باشد
      </span>


    toast.error(message, { autoClose: false })
  }

  return true
}

export default isStockLimited